import * as Icons from './icons';
import * as Images from './images';

export const Resources = {
  Icons,
  Images,
};
